import {Dropdown} from "bootstrap";
import PageLoadedQueue from "./PageLoadedQueue";

class DropdownHelper {
    private static instanceMap: Map<HTMLElement, DropdownHelper> = new Map();

    protected config = {
        popperConfig: {}
    };

    protected dropdownEl: HTMLElement;
    protected dropdown: Dropdown;

    constructor(dropdownEl: HTMLElement) {
        if (dropdownEl.dataset.plandentPlacement) {
            // @ts-ignore
            this.config.popperConfig.placement = dropdownEl.dataset.plandentPlacement;
        }

        this.dropdownEl = dropdownEl;
        this.dropdown = Dropdown.getOrCreateInstance(dropdownEl, this.config);

        dropdownEl.addEventListener('click', () => {
            this.dropdown.toggle();
        }, {passive: true});

        // Dropdown-Hover
        if (dropdownEl.classList.contains('dropdown-hover') || dropdownEl.parentElement.classList.contains('dropdown-hover')) {
            dropdownEl.parentElement.addEventListener('mouseenter', this.show, false);
            dropdownEl.parentElement.addEventListener('mouseleave', this.hide, false);
        }

        dropdownEl.dataset.plandentDropdownInit = "1";
    }

    public toggle = () => {
        this.dropdown.toggle();
    }

    public hide = () => {
        this.dropdown.hide();
    }

    public show = () => {
        this.dropdown.show();
    }

    public dispose = () => {
        this.dropdown.dispose();
    }

    public update = () => {
        this.dropdown.update();
    }

    public getDropdown = () => {
        return this.dropdown;
    }

    public getDropdownElement = () => {
        return this.dropdownEl;
    }

    /**
     * Get or create a new dropdown
     *
     * @param dropdownEl
     */
    public static getOrCreateInstance = (dropdownEl: HTMLElement): DropdownHelper => {
        if (!DropdownHelper.instanceMap.has(dropdownEl)) {
            DropdownHelper.instanceMap.set(dropdownEl, new DropdownHelper(dropdownEl));
        }

        return DropdownHelper.instanceMap.get(dropdownEl);
    }

    /**
     * Create Dropdown-Instances from a NodeList of HTMLSelectElements or a selector string
     *
     * @param {NodeListOf<HTMLSelectElement>|string} elementList
     */
    static createInstances = (elementList: NodeListOf<HTMLSelectElement> | string) => {
        if (typeof elementList === 'string') {
            elementList = document.querySelectorAll(elementList);
        }

        if (elementList.length > 0) {
            Array.from(elementList).forEach((el) => {
                DropdownHelper.getOrCreateInstance(el);
            });
        }
    }

    static defaultInit = () => {
        const bootstrapLegacy = '[data-toggle="dropdown"]:not([data-plandent-dropdown-init="1"])';
        DropdownHelper.createInstances(bootstrapLegacy);

        const bootstrapNew = '[data-bs-toggle="dropdown"]:not([data-plandent-dropdown-init="1"])';
        DropdownHelper.createInstances(bootstrapNew);

        const plandentDropdown = '[data-plandent-toggle="dropdown"]:not([data-plandent-dropdown-init="1"])';
        DropdownHelper.createInstances(plandentDropdown);
    }
}

PageLoadedQueue.addFunction(DropdownHelper.defaultInit);

document.addEventListener('plandent.reinit.bootstrapDropdown', DropdownHelper.defaultInit, {passive: true});

export default DropdownHelper;
